module.exports = __webpack_public_path__ + "img/st.57825d23.svg";